import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Hero from "../../components/AboutUs/Our-Offices/Hero"
import Maps from "../../components/AboutUs/Our-Offices/Maps"

const OurOffices = () => {
  return (
    <Layout>
      <SEO title="Our Offices" />
      <Hero />
      <Maps />
    </Layout>
  )
}

export default OurOffices
